import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as Layers from '@bubble-ui/particle-layers';
import { platformSelect } from '@bubble-ui/util-platform';
import generateInFieldsetStyle from '@bubble-ui/util-in-fieldset-style';
import { isLiquorice } from '@bubble-ui/particle-design-versions';
import * as FontFamilies from '@bubble-ui/particle-font-families';

var getDefaultStyleSheet = function getDefaultStyleSheet(_ref) {
  var autofill = _ref.autofill,
      darkBackground = _ref.darkBackground,
      disabled = _ref.disabled,
      error = _ref.error,
      errorLabel = _ref.errorLabel,
      fieldTooltip = _ref.fieldTooltip,
      focused = _ref.focused,
      hasLabel = _ref.hasLabel,
      hasValue = _ref.hasValue,
      hovered = _ref.hovered,
      icon = _ref.icon,
      obfuscatedValue = _ref.obfuscatedValue,
      position = _ref.position,
      squareBottomBorder = _ref.squareBottomBorder,
      stack = _ref.stack,
      tooltipActive = _ref.tooltipActive,
      warning = _ref.warning,
      warningLabel = _ref.warningLabel,
      width = _ref.width,
      cardNumberField = _ref.cardNumberField,
      designContext = _ref.designContext,
      designVersion = _ref.designVersion,
      isUnderlined = _ref.isUnderlined;
  var deprecatedFieldBackgroundColorTokenExists = designContext.hasTokenInContext('inputs/fields-boxed/background-color');
  var deprecatedFieldBorderColorTokenExists = designContext.hasTokenInContext('inputs/fields-boxed/border-color');
  var deprecatedFieldInputTextColorTokenExists = designContext.hasTokenInContext('inputs/fields-boxed/input-text-color');
  var deprecatedFieldLabelTextColorTokenExists = designContext.hasTokenInContext('inputs/fields-boxed/label-text-color');
  var deprecatedFieldInputTextStyleTokenExists = designContext.hasTokenInContext('inputs/fields-boxed/input-text-style');
  var deprecatedFieldLabelTextStyleTokenExists = designContext.hasTokenInContext('inputs/fields-boxed/label-text-style');
  var tokenArgs = {
    interactiveState: disabled ? 'disabled' : focused ? 'focused' : hovered ? 'hovered' : 'default',
    successState: autofill ? 'autofill' : error || errorLabel !== undefined ? 'error' : warning || warningLabel !== undefined ? 'warning' : 'default',
    background: darkBackground ? 'dark' : 'default'
  };
  var backgroundColor = designContext.get(deprecatedFieldBackgroundColorTokenExists ? 'inputs/fields-boxed/background-color' : 'field/background-color', tokenArgs);
  var borderColor = designContext.get(deprecatedFieldBorderColorTokenExists ? 'inputs/fields-boxed/border-color' : 'field/border-color', tokenArgs);
  var inputTextColor = designContext.get(deprecatedFieldInputTextColorTokenExists ? 'inputs/fields-boxed/input-text-color' : 'field/input-text-color', tokenArgs);
  var labelTextColor = designContext.get(deprecatedFieldLabelTextColorTokenExists ? 'inputs/fields-boxed/label-text-color' : 'field/label-text-color', tokenArgs);
  var inputTextStyle = designContext.get(deprecatedFieldInputTextStyleTokenExists ? 'inputs/fields-boxed/input-text-style' : 'field/input-text-style', tokenArgs);

  var _labelTextStyle = designContext.get(deprecatedFieldLabelTextStyleTokenExists ? 'inputs/fields-boxed/label-text-style' : 'field/label-text-style', tokenArgs);

  var fieldBorderRadius = designContext.get('field/corner-radius', {
    fieldType: isUnderlined ? 'underlined' : 'default'
  }).pixelValue;
  var showValue = !obfuscatedValue;
  var TRANSPARENT = 'rgba(255, 255, 255, 0)';
  var inFieldsetStyle = generateInFieldsetStyle({
    position: position,
    width: width,
    stack: stack,
    isUnderlined: isUnderlined,
    squareBottomBorder: squareBottomBorder,
    borderRadius: fieldBorderRadius
  });

  var paragraphSecondaryCorrectFootprintStyle = _objectSpread(_objectSpread({
    color: designContext.get('colors/text/default').toString(),
    fontSize: 16
  }, FontFamilies.KLARNA_TEXT_REGULAR), {}, {
    lineHeight: 25,
    WebkitFontSmoothing: 'antialiased',
    textAlign: 'left',
    wordBreak: 'break-word',
    marginBottom: -10,
    marginTop: -10,
    paddingBottom: 3,
    paddingTop: 2
  });

  return {
    rootStyle: _objectSpread({
      WebkitTapHighlightColor: TRANSPARENT,
      flexGrow: 1,
      flexShrink: 1,
      zIndex: tooltipActive ? Layers.TOOLTIP : focused ? Layers.FOCUS : error ? Layers.ERROR : warning ? Layers.WARNING : hovered ? Layers.HOVER // Android workaround: Field loses focus when switching from undefined to number for zIndex.
      // This causes a problem with autoFocus. Otherwise undefined would also work as default
      : Layers.BASE
    }, !position ? {
      maxWidth: inFieldsetStyle === null || inFieldsetStyle === void 0 ? void 0 : inFieldsetStyle.width
    } : {}),
    inputStyle: _objectSpread(_objectSpread(_objectSpread({
      boxShadow: 'none',
      caretColor: inputTextColor.toString(),
      color: showValue ? inputTextColor.toString() : TRANSPARENT
    }, platformSelect({
      web: {
        WebkitTextFillColor: showValue ? inputTextColor.toString() : TRANSPARENT
      },
      default: {}
    })), {}, {
      opacity: 1
    }, inputTextStyle.styles()), {}, {
      height: 60,
      overflow: 'hidden',
      paddingLeft: 0,
      paddingTop: hasLabel ? 18 : 0,
      position: 'absolute',
      textOverflow: 'ellipsis',
      top: 0,
      marginLeft: -1,
      marginTop: platformSelect({
        ios: 1,
        android: 6.5,
        default: 2
      }),
      whiteSpace: 'nowrap',
      width: '100%'
    }),
    containerStyle: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      alignItems: 'stretch',
      borderWidth: darkBackground || isUnderlined ? 0 : 1
    }, isUnderlined ? focused ? {
      borderBottomWidth: 2
    } : {
      borderBottomWidth: 1
    } : {}), {}, {
      borderStyle: 'solid',
      boxSizing: 'border-box',
      flexDirection: 'row',
      height: errorLabel !== undefined || warningLabel !== undefined ? 95 : 60,
      justifyContent: 'space-between'
    }, cardNumberField ? {
      paddingLeft: 6,
      paddingRight: 6,
      paddingTop: 15,
      paddingBottom: 15
    } : {
      paddingTop: 15,
      paddingBottom: 15,
      paddingLeft: isUnderlined ? 0 : 15,
      paddingRight: isUnderlined ? 0 : 15
    }), fieldTooltip ? isUnderlined ? {
      paddingRight: 20
    } : {
      paddingRight: 35
    } : {}), {}, {
      position: 'relative',
      backgroundColor: backgroundColor.toString(),
      borderColor: borderColor.toString()
    }, inFieldsetStyle),
    errorLabelWrapperStyle: {
      width: '100%',
      position: 'absolute',
      flexDirection: 'row',
      height: 35,
      bottom: 0,
      left: 0,
      right: 0
    },
    errorLabelTextWrapperStyle: {
      paddingTop: 5,
      width: '100%',
      overflow: 'hidden',
      height: 25
    },
    warningLabelWrapperStyle: {
      width: '100%',
      position: 'absolute',
      flexDirection: 'row',
      height: 35,
      bottom: 0,
      left: 0,
      right: 0
    },
    warningLabelTextWrapperStyle: {
      paddingTop: 5,
      width: '100%',
      overflow: 'hidden',
      height: 25
    },
    labelTextStyle: function labelTextStyle(fontSize) {
      return _objectSpread(_objectSpread({
        color: labelTextColor.toString()
      }, _labelTextStyle.styles()), {}, {
        fontSize: Number(fontSize),
        lineHeight: 30,
        overflow: 'hidden',
        textAlign: 'left',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        marginBottom: -30
      }, error || warning ? _objectSpread({
        marginLeft: 25
      }, platformSelect({
        web: {
          boxSizing: 'border-box'
        },
        native: {}
      })) : {});
    },
    labelViewStyle: function labelViewStyle(marginTop) {
      return {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        position: 'relative',
        marginLeft: (error || warning) && icon ? -26 : -1,
        pointerEvents: 'none',
        marginTop: marginTop,
        width: '100%'
      };
    },
    labelFeedbackStateColor: function labelFeedbackStateColor(_ref2) {
      var _ref3 = _slicedToArray(_ref2, 4),
          R = _ref3[0],
          G = _ref3[1],
          B = _ref3[2],
          A = _ref3[3];

      return {
        color: "rgba(".concat(Math.round(R), ", ").concat(Math.round(G), ", ").concat(Math.round(B), ", ").concat(A, ")")
      };
    },
    labelFeedbackStateIconStyle: {
      width: 20,
      height: 20,
      position: 'absolute',
      top: platformSelect({
        ios: 5,
        android: 5,
        web: 4
      }),
      left: icon ? 0 : 0
    },
    iconColorStyle: icon ? icon.props.colorToken ? {
      colorToken: icon.props.colorToken,
      colorTokenArgs: icon.props.colorTokenArgs || disabled && {
        interactiveState: 'disabled'
      } || undefined
    } : disabled ? {
      colorToken: 'colors/text/default',
      colorTokenArgs: {
        interactiveState: 'disabled'
      }
    } : icon.props.color ? {
      color: icon.props.color
    } : {
      colorToken: focused || hasValue || error || warning ? 'colors/text/default' : 'colors/text/neutral'
    } : {},
    cardWrapperStyle: _objectSpread({
      alignSelf: 'center',
      marginRight: cardNumberField ? 6 : 15
    }, cardNumberField && {
      width: 38
    }),
    iconStyle: {
      alignSelf: 'center',
      height: 20,
      left: -1
    },
    cardLogoStyle: {
      alignSelf: 'center',
      opacity: disabled ? 0.5 : 1,
      height: 22
    },
    loaderStyle: {
      alignSelf: 'center',
      paddingLeft: 5
    },
    textWrapperStyle: {
      flexGrow: 0,
      flexShrink: 1,
      position: 'relative',
      top: -16,
      width: '100%'
    },
    linkWrapperStyle: {
      paddingLeft: 5,
      marginTop: 1,
      marginRight: -5
    },
    obfuscatedValueWrapperStyle: {
      marginLeft: -1,
      marginTop: platformSelect({
        ios: 0,
        android: -0.5,
        web: -1
      }),
      pointerEvents: 'none',
      paddingTop: 30,
      marginBottom: -30
    },
    obfuscatedValueStyle: _objectSpread(_objectSpread({
      color: inputTextColor.toString()
    }, inputTextStyle.styles()), {}, {
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'left',
      marginBottom: -10,
      marginTop: platformSelect({
        ios: isLiquorice(designVersion) ? -10 : -5,
        android: isLiquorice(designVersion) ? -10 : -4.5,
        web: -10
      }),
      paddingBottom: 3,
      paddingTop: 2
    }),
    paragraphSecondaryCorrectFootprintStyle: paragraphSecondaryCorrectFootprintStyle,
    paragraphSecondaryCorrectFootprintErrorStyle: _objectSpread(_objectSpread({}, paragraphSecondaryCorrectFootprintStyle), {}, {
      color: designContext.get('colors/text/error').toString()
    }),
    paragraphSecondaryCorrectFootprintWarningStyle: _objectSpread(_objectSpread({}, paragraphSecondaryCorrectFootprintStyle), {}, {
      color: designContext.get('colors/text/warning').toString()
    })
  };
};

export default getDefaultStyleSheet;
//# sourceMappingURL=getDefaultStyleSheet.js.map